module.exports = __webpack_public_path__ + "static/media/priceRed.7c739a6b.svg";